
import sc from 'styled-components';
import theme from '@phonectas/unifon-ui-kit/dist/theme/theme';

export const TabButton = sc.button<{$active: boolean}>`
    padding: 10px 24px;
    background: ${({$active}) => ($active ? theme.palette.primary : '#fff')};
    color: ${({$active}) => ($active ? '#fff' : theme.palette.primary)};
    border: none;
    outline: none;
    font-size: 1rem;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    border-radius: 0;
    font-weight: 400;

    &:first-child {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }
    &:last-child {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }
`;

export const TabsContainer = sc.div`
    display: flex;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #dbe2ef;
    background: #fff;
    width: fit-content;
`;

export const TabRadioLabel = sc.label<{
    $active?: boolean;
    $first?: boolean;
    $last?: boolean;
    disabled?: boolean;
}>`
    flex: 1 1 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    flex-wrap: nowrap;
    background: ${({$active}) => ($active ? theme.palette.primary : '#fff')};
    color: ${({$active}) => ($active ? '#fff' : theme.palette.primary)};
    cursor: ${({disabled}) => (disabled ? 'not-allowed' : 'pointer')};
    transition: background 0.4s, color 0.4s;
    border: none;
    outline: none;
    border-radius: 0;
    position: relative;
    user-select: none;
    cursor: pointer;

    ${({$first}) =>
		$first &&
        `
            border-top-left-radius: 12px;
            border-bottom-left-radius: 12px;
        `}
    ${({$last}) =>
		$last &&
        `
            border-top-right-radius: 12px;
            border-bottom-right-radius: 12px;
        `}
    ${({disabled}) =>
		disabled &&
        `
            background: #f0f0f0;
            color: #aaa;
        `}

    span {
        width: 100%;
        text-align: center;
        pointer-events: none;
        white-space: nowrap;
    }
`;

export const TabRadio = sc.input.attrs({type: 'radio'})`
    position: absolute;
    opacity: 0;
    pointer-events: none;
`;
